export enum Theme {
    LIGHT = 'light',
    DARK = 'dark',
    NAVY = 'navy',
}
